import { Controller } from "@hotwired/stimulus"

// Live preview of the fixed ZNS reminder on the reminder-settings form: the
// message copy is registered with Zalo and immutable, so the preview only
// mirrors the two owner-editable injected values (service noun, address).
// Blank inputs fall back exactly like Messaging::ZnsAdapter does at send time.
export default class extends Controller {
  static targets = ["serviceInput", "addressInput", "serviceOut", "addressOut"]
  static values = { serviceFallback: String, addressFallback: String }

  connect() {
    this.update()
  }

  update() {
    this.serviceOutTarget.textContent =
      this.serviceInputTarget.value.trim() || this.serviceFallbackValue
    this.addressOutTarget.textContent =
      this.addressInputTarget.value.trim() || this.addressFallbackValue
  }
}
